"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.SubHeading=exports.ModalContainer=exports.ButtonsContainer=void 0;const ModalContainer=exports.ModalContainer=_styledComponents.default.div`
 min-width: 200px;
  height: content-fit;
  text-align: left;
  max-width: 360px;
  max-height: calc(100vh - 7em);
  /* max-height: 375px; */
  /* padding: 8px; */

  .imageContainer{
    display: flex;
    flex-direction: column;
  }
  .crossContainer{
    display: flex;
    justify-content: flex-end !important;
  }

  .closeButton{
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  .bagContainer{
    display: flex;
    justify-content: center;
  }

  .imageDimension{
    height: 110px;
    width: 80px;
  }

  .desc{
    line-height: 32px;
    text-align: center;
    font-size: 16px;
  }
  .cashbackStyle{
    text-decoration: underline;
    color: #2a2928 !important;
  }

  .subheading-container{
    display: flex;
    align-items: center;
  }
  .heading {
    text-align: center;
    margin: 12px !important;
    font-size: 20px;
  }
`,ButtonsContainer=exports.ButtonsContainer=_styledComponents.default.div`
display:flex;
flex-direction: row;
justify-content:center;
align-items:center;
 `,SubHeading=exports.SubHeading=_styledComponents.default.p`
 font-size: 20px;
 font-weight: 600;
 font-size: 20px;
 line-height: 32px;
 color: #330A0B;
 width: 90%;
 align-items: center;
 `;